/**
 * defa.models.UnitTest
 * The DEFA UnitTest model.
 * @version 1.2.0
 */
import Model from 'scripts/poppet/model';

const UnitTest = Model.extend( {
	
	defaults: {
		info : '', // html describing troubleshooting.
		title: '',
		tests: {},
	},
	
} );

export default UnitTest;